module.exports = __webpack_public_path__ + "img/dcb_biaot.ca711cfb.png";